export default __webpack_public_path__ + "static/media/lung_ng.e38d2a4f.jpg";